import { Alert, AlertTitle, Box, Modal, Snackbar, SnackbarCloseReason, Theme, Typography, useMediaQuery, useTheme } from '@mui/material';
import * as React from 'react';
import { useNetworkInformation } from '../shared/useNetworkInformation';
import { TCustomTheme } from '../theme';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { Dispatch, SetStateAction, useContext } from 'react';

type Props = {
  isOnline: boolean;
  theme: TCustomTheme;
};
export const NetworkContext = React.createContext<{
  setIsPlayerPath: Dispatch<SetStateAction<boolean>>;
  isPlayerPath: boolean;
}>({ setIsPlayerPath: () => null, isPlayerPath: false });

const PlayerNotifier = ({ isOnline, theme }: Props) => {
    const isDesktop = useMediaQuery((theme: Theme) => theme.breakpoints.up('sm'));
  
  return (
    <Snackbar
      open={!isOnline}
      onClose={(_, reason?: SnackbarCloseReason) => {
        if (reason === 'clickaway') {
          return;
        }
      }}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={!isDesktop ? { top: '75px' } : undefined}
    >
      <Alert
        sx={{
          '.circle': {
            borderRadius: '50%',
            border: `2px solid ${theme.palette.primary.main}`,
            padding: '5px',
          },
          background: theme.palette.contentBackground.main,
          color: theme.palette.text.primary,
        }}
        icon={
          <div className="circle">
            <WifiOffIcon sx={{ color: theme.palette.primary.main }} fontSize="inherit" />
          </div>
        }
      >
        <AlertTitle>You're offline now</AlertTitle>
        Your internet connection has been lost.
        To continue, reconnect to the internet.
      </Alert>
    </Snackbar>
  );
};

const GlobalNotifier = ({ isOnline, theme }: Props) => {
return (
    <Modal open={!isOnline} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <WifiOffIcon sx={{ color: theme.palette.primary.main, width: '8em', height: '8em' }} />
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2, color: '#FFFFFF', fontSize: '36px', fontWeight: 700, textShadow: '0 0 6px rgba(0, 0, 0, 0.8)' }}
        >
          You're offline now
        </Typography>
        <Typography
          id="modal-modal-description"
          sx={{ mt: 2, color: '#FFFFFF', textShadow: '0 0 6px rgba(0, 0, 0, 0.8)' }}
        >
          Your internet connection has been lost
        </Typography>
      </Box>
    </Modal>
  );
}

export const NetworkNotifier = () => {
  const isOnline = useNetworkInformation();
  const theme: TCustomTheme = useTheme();
  const networkContext = useContext(NetworkContext);

  if (networkContext.isPlayerPath) {
    return <PlayerNotifier isOnline={isOnline} theme={theme} />;
  }
  return <GlobalNotifier isOnline={isOnline} theme={theme}/>

  
};

